<script>
export default {
    name: "VisioneyeIcon"
}
</script>
<template>
    <svg  aria-hidden="true" width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 0C4.725 0 1.09375 5.33214 0 8C1.09375 10.6679 4.725 16 10.5 16C16.275 16 19.9062 10.6679 21 8C19.9062 5.33214 16.275 0 10.5 0ZM5.25 8C5.25 6.63603 5.80312 5.32792 6.78769 4.36345C7.77225 3.39898 9.10761 2.85714 10.5 2.85714C11.8924 2.85714 13.2277 3.39898 14.2123 4.36345C15.1969 5.32792 15.75 6.63603 15.75 8C15.75 9.36397 15.1969 10.6721 14.2123 11.6365C13.2277 12.601 11.8924 13.1429 10.5 13.1429C9.10761 13.1429 7.77225 12.601 6.78769 11.6365C5.80312 10.6721 5.25 9.36397 5.25 8ZM7 8C7 9.89286 8.56771 11.4286 10.5 11.4286C12.4323 11.4286 14 9.89286 14 8C14 6.10714 12.4323 4.57143 10.5 4.57143C10.2667 4.57143 10.037 4.59286 9.81458 4.63571L10.5 8L7.06562 7.32857C7.02187 7.54643 7 7.77143 7 8Z" fill="#F2EFEC"/>
    </svg>
</template>
